import React, { useEffect } from 'react';
import useAdminUserSWR from '../../../../hooks/admin/useAdminUserSWR';
import { SWRTable } from '../../../shared/Table/SWRTable';
import {
    AdminUser,
    AdminUsersHeadCellContent,
    AdminUsersResp,
} from '../../../../models/Admin/AdminUsers';
import { AdminUsersTableRow } from '../../../admin/users/AdminUsersTableRow';
import { ADMIN_USERS_HEAD_CELLS } from '../../../../utils/constans/adminUsersHead';
import useProfileEditorDialog from '../../../../hooks/useProfileEditorDialog';
import useAddToCompanyDialog from '../../../../hooks/useAddToCompanyDialog';

export const AdminUsers = () => {
    const [page, setPage] = React.useState(1);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    const [search, setSearch] = React.useState('');
    const [userList, setUserList] = React.useState(null);
    const { users, isLoading, forceRefresh } = useAdminUserSWR({
        search: search,
        page: page,
        size: rowsPerPage,
    });
    const profileDialog = useProfileEditorDialog();
    const addToCompanyDialog = useAddToCompanyDialog();

    useEffect(() => {
        if (users) {
            setUserList(users);
        }
    }, [users, isLoading]);

    const defaultPaginateOptions = {
        lazyPaginate: true,
        size: rowsPerPage,
        page: page - 1,
        search: search,
    };

    const tableSettings = {
        tableHeadSettings: {
            translateNs: 'admin',
            translatePrefix: 'USERS.TABLE_HEAD',
            selectable: false,
            headContent: ADMIN_USERS_HEAD_CELLS,
        },
        tableToolbarSettings: {
            translateNs: 'admin',
            translatePrefix: 'USERS.TABLE_TOOLBAR',
        },
    };

    const handleChange = (size: number, page: number, filter: string) => {
        setSearch(filter);
        setPage(page + 1);
        setRowsPerPage(size);
    };

    useEffect(() => {
        if (profileDialog.profileDialogClosedWithSuccess) {
            forceRefresh().then((users) => {
                setUserList(users);
            });
            profileDialog.setProfileDialogClosedWithSuccess(false);
        }
    }, [profileDialog.profileDialogClosedWithSuccess]);

    useEffect(() => {
        if (addToCompanyDialog.addToCompanyDialogState.successfulSend) {
            forceRefresh().then((users) => {
                setUserList(users);
            });
            addToCompanyDialog.setSuccess(false);
        }
    }, [addToCompanyDialog.addToCompanyDialogState.successfulSend]);

    return (
        <>
            <SWRTable<AdminUser, AdminUsersHeadCellContent>
                listItems={userList ? userList.users : []}
                totalNumber={userList ? userList.max_item : 0}
                component={AdminUsersTableRow}
                handleChange={handleChange}
                paginateOptions={defaultPaginateOptions}
                tableSettings={tableSettings}
                forceRefresh={forceRefresh}
                isLoading={isLoading}
            />
        </>
    );
};
